import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Screen } from '../enum/screen.enum';
import { Translation } from '../interface/translation';
import { ApiService } from './api.service';

export class TranslationLoaderService implements TranslateLoader {
  constructor(private api: ApiService) {}

  getTranslation(lang: string): Observable<Record<string, string>> {
    return this.api
      .all(`translations/screen/${Screen.ADMIN}/locale/${lang}`)
      .get<Translation>()
      .pipe(
        catchError(() => of({ translation: {} })),
        map((data) => data.translation),
      );
  }
}
